import React from "react";
import { useParams } from "react-router-dom";

import PageHeader from "../../components/PageHeader/PageHeader";
import "./legal.scss";
import { useGetLegalDocumentQuery } from "../../features/api/legalApiSlice";

export default function LegalDocument() {
  // 1. Extract the active route parameter string matching your slugs ('privacy', 'terms', 'safety')
  const { slug } = useParams();

  // 2. Fetch the target data dynamically down the pipeline using RTK Query
  const { data: docData, isLoading, error } = useGetLegalDocumentQuery(slug);

  // 3. Render a clean structural loader skeleton layout while reading database logs
  if (isLoading) {
    return (
      <main className="legal-page legal-page--loading fuel-fade-in">
        <div className="legal-wrapper">
          <div className="legal-skeleton-spinner">
            Parsing matrix log files...
          </div>
        </div>
      </main>
    );
  }

  // 4. Render an error fallback view if a coordinate route fails or is missing
  if (error || !docData) {
    return (
      <main className="legal-page legal-page--error fuel-fade-in">
        <div className="legal-wrapper">
          <PageHeader
            kicker="404 Error Tracking"
            title="Document Not Logged"
            subtitle="The requested coordination log entry does not exist or failed to load."
          />
        </div>
      </main>
    );
  }

  // 5. Deconstruct the loaded dataset package properties safely
  const { title, lastUpdated, sections = [] } = docData;

  return (
    <main className="legal-page fuel-fade-in">
      <div className="legal-wrapper">
        <PageHeader
          kicker="Compliance & Safety"
          title={title}
          subtitle={`Last structural review: ${lastUpdated}`}
        />

        <article className="legal-card">
          {sections.map((sec, idx) => (
            <section key={idx} className="legal-section">
              <h2>
                <span className="section-num">0{idx + 1}.</span> {sec.heading}
              </h2>
              <div className="legal-section__body">
                {sec.paragraphs.map((p, pIdx) => (
                  <p key={pIdx}>{p}</p>
                ))}
              </div>
            </section>
          ))}
        </article>
      </div>
    </main>
  );
}
